import { useMutation } from '@tanstack/react-query'
import React, { useState } from 'react'
import { apiClient } from '../helpers/Axios'
import { useNavigate, useParams } from 'react-router-dom'
import SectionHead from '../components/SectionHead'
import Input from '../components/Form Elements/Input'
import Button from '../ui/Button'
import Wrapper from '../helpers/Wrapper'
import toast from 'react-hot-toast'

function ResetPassword() {

    const { token, id } = useParams()
    const [formData, setFormData] = useState({
        password: "", cpassword: ""
    })

    const handleFormChange = (event) => {
        const { id, value } = event.target
        setFormData({ ...formData, [id]: value })
    }

    const navigate = useNavigate()

    const { mutate, isPending } = useMutation({
        mutationFn: (formData) => {
            return apiClient.post(`/auth/reset/${id}/${token}`, formData)
        },
        onError: (e) => {
            toast.dismiss()
            toast.error(e?.response?.data || e?.message)
        },
        onSuccess: () => {
            navigate('/account/login')
        }
    })


    return (
        <Wrapper>
            <div className='w-full relative mx-auto max-w-xl my-16 space-y-10'>
                <SectionHead title="Reset account password" description="Home / Account Reset" />
                <div className="w-full relative flex-col flex gap-5">
                    <label htmlFor="password" className='space-y-2'>
                        <p>Password <small className='text-red-500'>*</small></p>
                        <Input id="password" type='password' value={formData.password} onChange={handleFormChange} />
                    </label>

                    <label htmlFor="cpassword" className='space-y-2'>
                        <p>Confirm Password <small className='text-red-500'>*</small></p>
                        <Input id="cpassword" type='password' value={formData.cpassword} onChange={handleFormChange} />
                    </label>

                    <Button loading={isPending} fullWidth onClick={() => mutate(formData)}>Reset Password</Button>
                </div>
            </div>
        </Wrapper>
    )
}

export default ResetPassword